import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@phosphor-icons/react';
import { Check } from '@phosphor-icons/react';
import type { PropsWithChildren } from 'react';
export type LineItemProps = PropsWithChildren & {
  icon?: Icon;
};
export function LineItem(t0) {
  const $ = _c(7);
  const {
    icon,
    children
  } = t0;
  const Icon = icon ?? Check;
  let t1;
  if ($[0] !== Icon) {
    t1 = <Icon width={20} height={20} weight="bold" />;
    $[0] = Icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <span>{children}</span>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <li className="grid grid-flow-col justify-start gap-2 font-body-small">{t1}{t2}</li>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}